import { isProPlusVisitor } from './commercialOperation.js'
import { routeBaseName } from './sitePresence.js'

export function welcomeOfferFor({ offer, loggedIn, user, isProPlus }) {
  if (!offer || isProPlus) return null
  if (loggedIn && user?.is_new_customer === false) return null
  return offer
}

export function isManualBannerVisible({ banner, start, end, now = new Date() }) {
  if (!banner) return false
  if (start && new Date(start) > now) return false
  if (end && new Date(end) < now) return false
  return true
}

export function isCheckoutRoute(routeName) {
  return /^panier(-|_|$)/.test(routeName || '')
}

function isOperationPage(routeName, operationSlug) {
  return Boolean(operationSlug) && routeBaseName(routeName) === operationSlug
}

export function topBannerKind({
  clockChange = null,
  operationBannerPhase = null,
  operationSlug = null,
  manualBannerVisible,
  welcomeOffer,
  routeName,
}) {
  if (clockChange && !isCheckoutRoute(routeName)) return 'clock'
  if (operationBannerPhase) {
    return isOperationPage(routeName, operationSlug) ? null : 'operation'
  }
  if (manualBannerVisible) return 'manual'
  if (welcomeOffer && !isCheckoutRoute(routeName)) return 'welcome'
  return null
}

export function codesForVisitor(codes, visitor) {
  const refused = isProPlusVisitor(visitor) ? 'individual' : 'pro'
  return (codes || []).filter(
    code => code?.account_type?.identifier !== refused
  )
}

export function bestFeaturedCode(codes) {
  const active = (codes || []).filter(code => Number(code?.value) > 0)
  const byValue = (a, b) => Number(b.value) - Number(a.value)
  const percentage = active.filter(code => isPercentage(code)).sort(byValue)
  if (percentage.length) return percentage[0]
  const amount = active.filter(code => !isPercentage(code)).sort(byValue)
  return amount[0] || null
}

export function isPercentage(code) {
  return (
    code?.code_mode_id === 1 || code?.code_mode?.identifier === 'percentage'
  )
}
